import { defineComponent } from "vue";
import { useRouter, useRoute } from 'vue-router';
export default defineComponent({
  setup() {
    const $route = useRoute();
    const $router = useRouter();
    /**
     * pageType:
     * takedown: 软件下架申请
     * applied 新版本申请 和 新增软件申请
     */
    const pageType = $route.params.page_type;
    const goBack = () => {
      $router.push({
        path: '/softwarelibrary'
      });
    };
    return {
      pageType,
      goBack,
      bglist: require('../assets/imgs/success-icon1.png')
    };
  }
});